<div class="commande head">
    <div class="container">
        <div class="card-header">
            <ul class="nav">
                <li class="nav-item deco on" (click)="goToSummary()">
                    <span class="title">RÉCAPITULATIF</span>
                    <span class="deco"></span>
                </li>
                <li class="nav-item deco" [class.on]="router.isActive('/checkout/authentification',false) || router.isActive('/checkout/confirmation',false)" *ngIf="!isAuthenticated">
                    <span class="title">CONNEXION</span>
                    <span class="deco"></span>
                </li>
                <li class="nav-item deco"[class.on]="router.isActive('/checkout/confirmation',false)">
                    <span class="title">CONFIRMATION</span>
                </li>
            </ul>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>